/// <reference path="WebService.ts" />

interface WebService
{
    removeBank( bank:Bank, completion:any ) : void ;
    removeBankAccount( account:BankAccount, completion:any ) : void ;
    importBankMovements(file:any, account:BankAccount, type:string, completion:any) : void ;
    bankMovementLinkSuggestions( movement:BankMovement, completion:any ) : void ;
    regenerateSEPAFile( file:BankTransferBundleFile, sepaType:string, account:BankAccount, completion:DLCompletionCallback ) : void ;
    markSEPAFileAsUploaded( file:BankTransferBundleFile, completion:DLCompletionCallback ) : void ;
    removeSEPAFile( file:BankTransferBundleFile, completion:DLCompletionCallback ) : void ;
}

WebService.prototype.bankMovementLinkSuggestions = function( movement:BankMovement, completion:any ) : void
{
    const url_str = this.apiURL + "/entity/" + this.scheme + "/BankMovement/" + movement.identifier + "/link-suggestions";
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        if (error) {
            completion(null, null, error);
            return;
        }

        let data = json["data"] ?? json;
        completion(data["inferredEntity"], data["suggestions"] ?? [], null);
    } );
}

WebService.prototype.removeBank = function( bank:Bank, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/bank/" + bank.identifier;
    let r = new DLRequest ( url_str, null, "DELETE" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}

WebService.prototype.removeBankAccount = function( account:BankAccount, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/bank-account/" + account.identifier;
    let r = new DLRequest ( url_str, null, "DELETE" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}

WebService.prototype.importBankMovements = function ( file:any, account:BankAccount, completion:any ) {    
    const cmd = new WebServiceCommand(this.integratorURL, "/schema/" + this.identifier + "/import/bank-movements/" + account.identifier);
    cmd.method = "POST";
    cmd.blobData = file;

    cmd.execute(this, function (code, json) {
        if (completion != null) completion(code == 200, json["data"]);
    });                        
}

//
// Bank bundle (SEPA) file operations. The three routes live in DLIntegratorServer BankRoutes.swift and
// refuse to touch a file with any installment already locked or processed by the bank.
//

// Same installments, current bank data of every legal entity. The reply carries the new content
// ({ reference, name, content }) instead of a raw download so a server failure reaches the user.
WebService.prototype.regenerateSEPAFile = function( file:BankTransferBundleFile, sepaType:string, account:BankAccount, completion:DLCompletionCallback ) : void
{
    const url_str = this.integratorURL + "/accounting/schema/" + this.scheme + "/sepa/file/" + file.identifier + "/regenerate";
    let r = new DLRequest ( url_str, { "BankAccountID": account.identifier, "SEPAType": sepaType }, "POST" );
    r.execute( completion );
}

// Locks every installment of the file (operation reference = file reference).
WebService.prototype.markSEPAFileAsUploaded = function( file:BankTransferBundleFile, completion:DLCompletionCallback ) : void
{
    const url_str = this.integratorURL + "/accounting/schema/" + this.scheme + "/sepa/file/" + file.identifier + "/mark-uploaded";
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( completion );
}

// Puts the installments back to pending, unlinks them and deletes the file.
WebService.prototype.removeSEPAFile = function( file:BankTransferBundleFile, completion:DLCompletionCallback ) : void
{
    const url_str = this.integratorURL + "/accounting/schema/" + this.scheme + "/sepa/file/" + file.identifier;
    let r = new DLRequest ( url_str, null, "DELETE" );
    r.execute( completion );
}
